import { Typography } from "@mui/material";
import React from "react";

const RenderGridElement = ({
  label,
  value,
}: {
  label: string;
  value: string;
}): React.JSX.Element => {
  return (
    <React.Fragment>
      <Typography variant="caption" color="span">
        {label}
      </Typography>
      <br />
      <Typography
        variant="body1"
        color="initial"
        sx={{ wordWrap: "break-all" }}
      >
        {value}
      </Typography>
    </React.Fragment>
  );
};

export default RenderGridElement;
